import React from "react";
import { Cog, Loader2, Menu, RefreshCw } from "lucide-react";
import { useAdminLayout } from "../AdminLayoutContext";

export default function AdminSystemChrome({
  loading,
  onRefresh,
  overview,
  jobCount,
  healthyCount,
}) {
  const { openMobileMenu } = useAdminLayout();
  const redisOk = Boolean(overview?.redis);

  return (
    <>
      <header className="am-chrome">
        <div className="am-chrome-row">
          <div className="am-chrome-lead">
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-icon lg:hidden"
              onClick={openMobileMenu}
              aria-label="Open menu"
            >
              <Menu size={16} strokeWidth={2.2} />
            </button>

            <div className="am-chrome-brand" aria-label="System Desk">
              <Cog size={12} strokeWidth={2.3} aria-hidden />
              <span>System Desk</span>
            </div>

            <div className="am-chrome-stats" aria-label="System summary">
              <span className="am-chrome-stat tabular-nums">
                <em>{jobCount ?? "—"}</em> jobs
              </span>
              <span className="am-chrome-stat tabular-nums">
                <em>{healthyCount ?? 0}</em> scheduled
              </span>
              <span
                className={`am-chrome-stat tabular-nums${redisOk ? " am-chrome-stat-live" : ""}`}
              >
                <em>{redisOk ? "Redis" : "Offline"}</em>
              </span>
            </div>
          </div>

          <div className="am-chrome-trail">
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-icon"
              onClick={onRefresh}
              disabled={loading}
              aria-label="Refresh system overview"
              title="Refresh"
            >
              {loading ? (
                <Loader2 size={14} className="am-spin" aria-hidden />
              ) : (
                <RefreshCw size={14} strokeWidth={2.3} />
              )}
            </button>
          </div>
        </div>
      </header>
      <div className="am-chrome-spacer" aria-hidden />
    </>
  );
}
